import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../lib/styles';

import { Article, Author } from '../../../../models/article';
import StoriesBlock from '../../../../components/presentational/StoriesBlock';
import Spacer from '../../../../components/presentational/Spacer';
import { Ads } from '../../../../components/presentational/Ad';
import blockStyles from './Block_styles';

export interface ArticleBlockData {
  type: 'article_block';
  articles: Article[];
  hideAds: boolean;
  hideStickyAd: boolean;
  hideTopAd: boolean;
  title?: string;
  subtitle?: string;
  moreArticlesURL: string;
  hideBottomAd: boolean;
  feature: 'top' | 'heavy';
  teaser: {
    showMoreText: string;
    title: string;
    titleOverride: string;
    article: Article;
  };
  aside: {
    icon: 'bookmark' | 'avatar';
    title: string;
    articles: Article[];
  };
  pagination: boolean;
  backfillCount: number;
  preferTrackingBackfill: boolean;
}

interface ArticleBlockProps {
  block: ArticleBlockData;
  ads: Ads;
  blockIndex: number;
  author: Author | undefined;
  hideAds: boolean;
  lazy: boolean;
  loadMore: (
    moreArticlesURL: string | undefined,
    i: number,
    articleIds: number[]
  ) => any;
  articleIds: number[];
  moreArticlesLoading: boolean | undefined;
}

const ArticleBlock = ({
  block,
  block: {
    articles,
    pagination,
    moreArticlesURL,
    teaser,
    aside,
    title,
    subtitle,
    hideStickyAd,
    hideTopAd,
    hideBottomAd,
    backfillCount,
    preferTrackingBackfill,  
  },
  ads,
  blockIndex,
  hideAds,
  author,
  loadMore,
  moreArticlesLoading,
  articleIds,
  styles,
}: ArticleBlockProps & StylesProps<typeof blockStyles>) => {
  const { hideAds: hideAdsFromBlock } = block;
  // console.log('ArticleBlock', { hideAds, hideAdsFromBlock, ads });
  return (
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <StoriesBlock
          {...(!hideAds && {
            stickyAd: !hideStickyAd ? ads.sticky : undefined,
            enterpriseAd: !hideStickyAd ? ads.enterprise : undefined,
            topAd: !hideTopAd ? ads.top : undefined,
            bottomAd: !hideBottomAd ? ads.bottom : undefined,
            recirculationAd1: ads.collection_recirculation_native1,
            recirculationAd2: ads.collection_recirculation_native2,
          })}
          author={author}
          attribute={!author}
          feature
          heading={title}
          subheading={subtitle}
          name={`${blockIndex}_story_section`}
          key={`${blockIndex}_story_section`}
          adIDSuffix={blockIndex.toString()}
          hideAds={hideAds}
          articles={articles}
          {...(pagination && {
            isLoading: !!moreArticlesLoading,
            hasMore: !!moreArticlesURL,
            onShowMore: () => loadMore(moreArticlesURL, blockIndex, articleIds),
          })}
          lazy={blockIndex !== 0}
          {...(teaser && {
            teaser: {
              title: teaser.title,
              showMoreText: teaser.showMoreText,
              article: {
                ...teaser.article,
                ...(teaser.titleOverride.length > 0 && {
                  title: teaser.titleOverride,
                }),
              },
            },
          })}
          {...(aside && {
            aside: {
              title: aside.title,
              articles: aside.articles,
            },
          })}
          backfillCount={backfillCount}
          preferTrackingBackfill={preferTrackingBackfill}
          blockIndex={blockIndex}
        />
      </Spacer>
    </div>
  );
};

export default compose(styled(blockStyles))(ArticleBlock);
